import React from "react";
import { Grid, Paper, Box, Typography } from "@mui/material";
// import PremiumIcon from "@mui/icons-material/WorkspacePremium";
// import BiotechIcon from "@mui/icons-material/Biotech";
import VerifiedIcon from "@mui/icons-material/Verified";
// import SpeedIcon from "@mui/icons-material/Speed";
import { SvgIconComponent } from "@mui/icons-material";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ScienceIcon from "@mui/icons-material/Science";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BoltIcon from "@mui/icons-material/Bolt";
import EngineeringIcon from "@mui/icons-material/Engineering";

/* ---------------- TYPES ---------------- */

interface StatCardProps {
  icon: SvgIconComponent;
  value: string | number;
  label: string;
  gradient: string;
  textColor?: string;
}

/* ---------------- STAT CARD COMPONENT ---------------- */

const StatCard: React.FC<StatCardProps> = ({
  icon: Icon,
  value,
  label,
  gradient,
  textColor = "white",
}) => {
  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: "16px",
        background: gradient,
        color: textColor,
        height: "100%",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Icon sx={{ fontSize: 40 }} />

        <Box>
          <Typography variant="h6" fontWeight={600}>
            {value}
          </Typography>
          <Typography variant="body2">{label}</Typography>
        </Box>
      </Box>
    </Paper>
  );
};

/* ---------------- DATA ---------------- */
const stats = [
  {
    icon: CorporateFareIcon,
    value: "50+",
    label: "Branches",
    gradient: "linear-gradient(135deg, #1976d2, #1565c0)", // corporate blue
  },
  {
    icon: ScienceIcon,
    value: "1500+",
    label: "Tests Available",
    gradient: "linear-gradient(135deg, #7b1fa2, #512da8)", // lab science purple
  },
  {
    icon: AssignmentIcon,
    value: "100+",
    label: "Test Profiles",
    gradient: "linear-gradient(135deg, #fb8c00, #ef6c00)", // medical orange
  },
  {
    icon: BoltIcon,
    value: "24/7",
    label: "Express Reports",
    gradient: "linear-gradient(135deg, #fdd835, #f9a825)", // fast yellow
    textColor: "#1a1a2e",
  },
  {
    icon: VerifiedIcon,
    value: "100%",
    label: "Accuracy",
    gradient: "linear-gradient(135deg, #43a047, #2e7d32)", // trust green
  },
  {
    icon: EngineeringIcon,
    value: "500+",
    label: "Technicians",
    gradient: "linear-gradient(135deg, #546e7a, #37474f)", // professional grey
  },
];

/* ---------------- MAIN COMPONENT ---------------- */

const CorporateStats: React.FC = () => {
  return (
    <Grid container spacing={3} sx={{ mb: 2 }}>
      {stats.map((stat, index) => (
        <Grid key={index} size={{ xs: 12, md: 2 }}>
          <StatCard {...stat} />
        </Grid>
      ))}
    </Grid>
  );
};

export default CorporateStats;